export default __webpack_public_path__ + "static/media/France-travail-2023.96e7d6a0.png";